import { constructEnum } from '@/lib/enum';

const WidgetType = constructEnum('WidgetType', {
  REVIEWS: 0,
  PRODUCT_REVIEWS: 100,
  PRODUCTS: 300,
  REVIEWS_SHOW: 500,
  REVIEWS_NEW: 510,
  REVIEWS_PHOTO_REVIEW_POPUP: 520,
  MANAGING_REVIEWS: 530,
  PRODUCT_REVIEWS_MEDIA_COLLAGE_POPUP: 540,
  REVIEW_PROMPT: 550,
  REVIEWS_SHORTS_POPUP: 560,
  ETC: 600,
  CATEGORY_REVIEWS: 700,
  ADD_ON: 800,
  SWITCHER: 10010
});

WidgetType.switchableWidgetType = [
  WidgetType.REVIEWS,
  WidgetType.PRODUCT_REVIEWS,
  WidgetType.PRODUCTS
];

export default WidgetType;
